import type Employment from '@sysarb/sysarb-api/models/entities/Employment';
import { SalaryTypes } from '@sysarb/sysarb-api/models/entities/Employment';

/**
 * `totalSalary` is only populated for employments paid per month or year — hourly employments carry
 * their pay in `hourlySalary` and would otherwise be plotted as 0. The two are not comparable, so
 * the Salaries section also filters on salary type rather than mixing them in one chart.
 */
export function isHourlySalaryType(salaryType: SalaryTypes): boolean {
    return salaryType === SalaryTypes.hourly || salaryType === SalaryTypes.hourlyTotalCompensation;
}

export function getEmploymentSalary(employment: Employment): number {
    return isHourlySalaryType(employment.salaryType.value) ? employment.hourlySalary : employment.totalSalary;
}
